const PERMISSION_KEY = "auth:permissions";

export const getPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem(PERMISSION_KEY)) || [];
  } catch {
    return [];
  }
};

export const can = (module, action) => {
  if (!module || !action) return false;

  const permissions = getPermissions();
  return permissions.includes(`${module}:${action}`);
};
